import React from "react"
import { Link } from "gatsby"
import GitHubImages from "../components/GitHubImages"
import PropTypes from "prop-types"
import "../css/search.css"
import UseLocalStorage from "../hooks/UseLocalStorage"

function AlgoliaHits(props) {
  const AllChampsDataKey = `LocalStorage-AllChampsDataKey`
  const [item, setItem] = UseLocalStorage(AllChampsDataKey)

  const placeholderData = {
    artifacts: [
      {
        id: 13434,
        sellPrice: 129600,
        price: 2592000,
        level: 16,
        isActivated: true,
        kind: "Cloak",
        rank: "Six",
        rarity: "Legendary",
        setKind: "None",
        isSeen: true,
        failedUpgrades: 0,
        primaryBonus: {
          kind: "CriticalDamage",
          isAbsolute: false,
          value: 0.4,
          enhancement: 0.0,
          level: 0,
        },
        secondaryBonuses: [
          {
            kind: "Accuracy",
            isAbsolute: true,
            value: 20.0,
            enhancement: 0.0,
            level: 1,
          },
          {
            kind: "Resistance",
            isAbsolute: true,
            value: 21.0,
            enhancement: 0.0,
            level: 1,
          },
          {
            kind: "Defense",
            isAbsolute: true,
            value: 56.0,
            enhancement: 0.0,
            level: 1,
          },
          {
            kind: "Health",
            isAbsolute: true,
            value: 709.0,
            enhancement: 0.0,
            level: 1,
          },
        ],
        requiredFraction: "LizardMen",
      },
    ],
    heroes: [
      {
        id: 104,
        typeId: 3362,
        grade: "Stars4",
        level: 40,
        experience: 0,
        fullExperience: 649763,
        locked: true,
        inStorage: true,
        artifacts: [44, 45, 53, 90, 107, 150, 573],
        fraction: "HighElves",
        rarity: "Rare",
        role: "Attack",
        element: "Magic",
        awakenLevel: 2,
        name: "Placeholder",
        health: 6870.0,
        accuracy: 0.0,
        attack: 601.0,
        defense: 452.0,
        criticalChance: 15.0,
        criticalDamage: 50.0,
        criticalHeal: 50.0,
        resistance: 30.0,
        speed: 94.0,
        masteries: [],
      },
    ],
    arenaLeague: "GoldIV",
    greatHall: {
      magic: {
        attack: 6,
        accuracy: 8,
        defense: 6,
        health: 8,
        criticalDamage: 6,
        resistance: 6,
      },
      spirit: {
        attack: 6,
        accuracy: 9,
        defense: 6,
        resistance: 6,
        criticalDamage: 6,
        health: 7,
      },
      force: {
        attack: 6,
        accuracy: 9,
        defense: 6,
        resistance: 6,
        criticalDamage: 6,
        health: 7,
      },
      void: {
        accuracy: 10,
        attack: 8,
        defense: 8,
        criticalDamage: 10,
        resistance: 8,
        health: 9,
      },
    },
    shards: {
      mystery: {
        count: 0,
        summonData: [
          {
            rarity: "Common",
            pullCount: 0,
            lastHeroId: 200,
          },
          {
            rarity: "Uncommon",
            pullCount: 0,
            lastHeroId: 5910,
          },
          {
            rarity: "Rare",
            pullCount: 0,
            lastHeroId: 2180,
          },
        ],
      },
      sacred: {
        count: 0,
        summonData: [
          {
            rarity: "Epic",
            pullCount: 0,
            lastHeroId: 1660,
          },
          {
            rarity: "Legendary",
            pullCount: 0,
            lastHeroId: 3570,
          },
        ],
      },
      void: {
        count: 0,
        summonData: [
          {
            rarity: "Rare",
            pullCount: 0,
            lastHeroId: 40,
          },
          {
            rarity: "Epic",
            pullCount: 0,
            lastHeroId: 1150,
          },
          {
            rarity: "Legendary",
            pullCount: 0,
            lastHeroId: 70,
          },
        ],
      },
      ancient: {
        count: 0,
        summonData: [
          {
            rarity: "Rare",
            pullCount: 0,
            lastHeroId: 2930,
          },
          {
            rarity: "Epic",
            pullCount: 0,
            lastHeroId: 2470,
          },
          {
            rarity: "Legendary",
            pullCount: 0,
            lastHeroId: 2530,
          },
        ],
      },
    },
  }

  if (!item) {
    setItem(AllChampsDataKey, JSON.stringify(placeholderData))
    window.location.reload()
  }

  const data = JSON.parse(item)
  const champs = data.heroes

  /*   function getNames(object) {
    var names = []
    for (var key in object) {
      if (!object.hasOwnProperty(key)) continue
      names.push(object[key].name)
    }
    return names
  } */

  /*   function getSlugs(object) {
    var slugs = []
    for (var key in object) {
      if (!object.hasOwnProperty(key)) continue
      slugs.push(object[key].name.replace(/\s+/g, "-").toLowerCase())
    }
    return slugs
  } */

  function getPaths(object) {
    var paths = []
    for (var key in object) {
      var slug = object[key].name.replace(/\s+/g, "-").toLowerCase()
      if (!object.hasOwnProperty(key)) continue
      paths.push(
        `champions/${slug.replace(/'+/g, "-")}`
      )
    }
    return paths
  }

  //const myChampSlugs = getSlugs(champs)
  //const myChampNames = getNames(champs)
  const myChampPaths = getPaths(champs)

  //alert(myChampPaths);
  const auraArea = props.hit.auraLocation

  const champSlugBeforeRemovingSingleQuotes = props.hit.title

  const regexMaShalledSingleQuote = /’+/g
  const regexBigUnSingleQuote = /\s+‘+/g
  const regexNormalSingleQuote = /'+/g
  const dash = `-`

  const champSlugBeforeRemovingBigUnSingleQuote = champSlugBeforeRemovingSingleQuotes.replace(
    regexMaShalledSingleQuote,
    dash
  )
  const champSlugBeforeRemovingNormalSingleQuote = champSlugBeforeRemovingBigUnSingleQuote.replace(
    regexBigUnSingleQuote,
    dash
  )

  const champSlugBeforeReplacingSpacesWithDashes = champSlugBeforeRemovingNormalSingleQuote.replace(
    regexNormalSingleQuote,
    dash
  )
  const champSlugBeforeReplacingDoubleDashesWithSingleDash = champSlugBeforeReplacingSpacesWithDashes
    .replace(/\s+/g, "-")
    .toLowerCase()

  var champSlug = champSlugBeforeReplacingDoubleDashesWithSingleDash.replace(/--/g, "-")

  if (champName === "Cornellia") {
  
    var champSlug = "conellia"
    var champName = "Conellia"

  }


  if (champName === "Hero 6200 name") {

    var champSlug = "ninja"
    var champName = "Ninja"

  }



  
  if (champName === "Big 'Un") {

    var champSlug = "big-un"
    var champName = "Big 'Un"

  }



  if (champName === "Ma'Shalled") {

    var champSlug = "ma-shalled"
    var champName = "Ma'Shalled"

  }

  return (
    <div
      className={
        myChampPaths.includes(props.hit.path)
          ? "item-wrap myChamp"
          : "item-wrap notMyChamp"
      }
    >
      <div className="item-image-wrap">
        <div className="hit-rarity">
          <Link to={`${process.env.PUBLIC_URL}/champions/${champSlug}`}>
            {props.hit.rarity.includes("Common") ? (
              <div className="hit-rarity-img-wrap Common">
                <div className="hit-rarity-img-overlay"></div>
                {/*<img src={props.hit.image} align="left" alt={props.hit.name} title={props.hit.name} />*/}
                <picture>
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.webp`} type="image/webp" />
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.png`} type="image/png" />
                  <img
                    src={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.png`}
                    align="left"
                    alt={props.hit.title}
                    title={props.hit.title}
                  />
                </picture>
              </div>
            ) : (
              <div className="hidden"></div>
            )}
            {props.hit.rarity.includes("Uncommon") ? (
              <div className="hit-rarity-img-wrap Uncommon">
                <div className="hit-rarity-img-overlay"></div>
                {/*<img src={props.hit.image} align="left" alt={props.hit.name} title={props.hit.name} />*/}
                <picture>
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.webp`} type="image/webp" />
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.png`} type="image/png" />
                  <img
                    src={props.hit.image}
                    align="left"
                    alt={props.hit.title}
                    title={props.hit.title}
                  />
                </picture>
              </div>
            ) : (
              <div className="hidden"></div>
            )}
            {props.hit.rarity.includes("Rare") ? (
              <div className="hit-rarity-img-wrap Rare">
                <div className="hit-rarity-img-overlay"></div>
                {/*<img src={props.hit.image} align="left" alt={props.hit.name} title={props.hit.name} />*/}
                <picture>
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.webp`} type="image/webp" />
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.png`} type="image/png" />
                  <img
                    src={props.hit.image}
                    align="left"
                    alt={props.hit.title}
                    title={props.hit.title}
                  />
                </picture>
              </div>
            ) : (
              <div className="hidden"></div>
            )}
            {props.hit.rarity.includes("Epic") ? (
              <div className="hit-rarity-img-wrap Epic">
                <div className="hit-rarity-img-overlay"></div>
                {/*<img src={props.hit.image} align="left" alt={props.hit.name} title={props.hit.name} />*/}
                <picture>
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.webp`} type="image/webp" />
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.png`} type="image/png" />
                  <img
                    src={props.hit.image}
                    align="left"
                    alt={props.hit.title}
                    title={props.hit.title}
                  />
                </picture>
              </div>
            ) : (
              <div className="hidden"></div>
            )}
            {props.hit.rarity.includes("Legendary") ? (
              <div className="hit-rarity-img-wrap Legendary">
                <div className="hit-rarity-img-overlay"></div>
                {/*<img src={props.hit.image} align="left" alt={props.hit.name} title={props.hit.name} />*/}
                <picture>
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.webp`} type="image/webp" />
                  <source srcset={`https://raw.githubusercontent.com/raidchamps/static-data/main/images/avatar/${champSlug}/image.png`} type="image/png" />
                  <img
                    src={props.hit.image}
                    align="left"
                    alt={props.hit.title}
                    title={props.hit.title}
                  />
                </picture>
              </div>
            ) : (
              <div className="hidden"></div>
            )}
          </Link>
        </div>
        {/* hit-rarity */}
        {/*        <table className="hit-neededForFusion">
          {props.hit.neededForFusion  > " " ?
            <div className={props.hit.neededForFusion.indexOf('Active') > -1 ? 'neededForFusion currentlyActive' : 'neededForFusion'}>
              <GitHubImages whichDirectory="AvatarIconImages/RaidChamps" whichImage="Fusion"
                alt=
                  {props.hit.neededForFusion.map(items => (
                    [` ${items}`]
                  ))}
                title=
                  {props.hit.neededForFusion.map(items => (
                    [` ${items}`]
                  ))}
              />
            </div>
          :
            <div className="hidden"></div>
          }
        </table>*/}{" "}
        {/* hit-neededForFusion */}
        <div className="hit-affinity">
                {props.hit.affinity.indexOf('Force')  > -1 ?
                  <div className="hit-affinity-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Affinity" whichImage="force" title="Force Affinity" alt="Force Affinity" />
                  </div>
                :
                  <div className="hidden"></div>
                }
                {props.hit.affinity.indexOf('Magic')  > -1 ?
                  <div className="hit-affinity-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Affinity" whichImage="magic" title="Magic Affinity" alt="Magic Affinity" />
                  </div>
                :
                  <div className="hidden"></div>
                }
                {props.hit.affinity.indexOf('Spirit')  > -1 ?
                  <div className="hit-affinity-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Affinity" whichImage="spirit" title="Spirit Affinity" alt="Spirit Affinity" />
                  </div>
                :
                  <div className="hidden"></div>
                }
                {props.hit.affinity.indexOf('Void')  > -1 ?
                  <div className="hit-affinity-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Affinity" whichImage="void" title="Void Affinity" alt="Void Affinity" />
                  </div>
                :
                  <div className="hidden"></div>
                }
        </div>
        {/* hit-affinity */}
        {props.hit.auraStat ? (
          <div>
            {props.hit.auraPercentage ? (
              <div className="hit-aura">
                {props.hit.auraStat.includes("Attack") ? (
                  <div className="hit-aura-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Aura"
                      whichImage="Attack"
                      title={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation}  by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                      alt={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation} by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                    />
                  </div>
                ) : (
                  <div className="hidden"></div>
                )}
                {props.hit.auraStat.includes("Critical Rate") ? (
                  <div className="hit-aura-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Aura"
                      whichImage="Crit_Rate"
                      title={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation}  by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                      alt={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation}  by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                    />
                  </div>
                ) : (
                  <div className="hidden"></div>
                )}
                {props.hit.auraStat.includes("Defense") ? (
                  <div className="hit-aura-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Aura"
                      whichImage="Defense"
                      title={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation}  by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                      alt={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation}  by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                    />
                  </div>
                ) : (
                  <div className="hidden"></div>
                )}
                {props.hit.auraStat.includes("HP") ? (
                  <div className="hit-aura-img-wrap">
                    <GitHubImages whichDirectory="AvatarIconImages/Aura"
                      whichImage="HP"
                      title={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation}  by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                      alt={`Increase ${props.hit.auraAffinity} Ally ${
                        props.hit.auraStat
                      } in ${props.hit.auraLocation}  by ${
                        !props.hit.auraPercentage === 0
                          ? props.hit.auraPercentage
                          : ""
                      }${
                        !props.hit.auraFlatIncrease === 0
                          ? props.hit.auraFlatIncrease
                          : ""
                      }`}
                    />
                  </div>
                ) : (
                  <div className="hidden"></div>
                )}
              </div>
            ) : (
              <div>
                {props.hit.auraFlatIncrease &&
                props.hit.auraStat === "Accuracy" ? (
                  <div className="hit-aura">
                    <div className="hit-aura-img-wrap">
                      <GitHubImages whichDirectory="AvatarIconImages/Aura"
                        whichImage="Accuracy"
                        title={`Increase ${props.hit.auraAffinity} Ally ${
                          props.hit.auraStat
                        } in ${props.hit.auraLocation}  by ${
                          !props.hit.auraPercentage === 0
                            ? props.hit.auraPercentage
                            : ""
                        }${
                          !props.hit.auraFlatIncrease === 0
                            ? props.hit.auraFlatIncrease
                            : ""
                        }`}
                        alt={`Increase ${props.hit.auraAffinity} Ally ${
                          props.hit.auraStat
                        } in ${props.hit.auraLocation}  by ${
                          !props.hit.auraPercentage === 0
                            ? props.hit.auraPercentage
                            : ""
                        }${
                          !props.hit.auraFlatIncrease === 0
                            ? props.hit.auraFlatIncrease
                            : ""
                        }`}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="hidden"></div>
                )}{" "}
                {/* props.hit.auraFlatIncrease && props.hit.auraStat === "Accuracy" */}
                {props.hit.auraFlatIncrease &&
                props.hit.auraStat === "Resist" ? (
                  <div className="hit-aura">
                    <div className="hit-aura-img-wrap">
                      <GitHubImages whichDirectory="AvatarIconImages/Aura"
                        whichImage="Resist"
                        title={`Increase ${props.hit.auraAffinity} Ally ${
                          props.hit.auraStat
                        } in ${props.hit.auraLocation}  by ${
                          !props.hit.auraPercentage === 0
                            ? props.hit.auraPercentage
                            : ""
                        }${
                          !props.hit.auraFlatIncrease === 0
                            ? props.hit.auraFlatIncrease
                            : ""
                        }`}
                        alt={`Increase ${props.hit.auraAffinity} Ally ${
                          props.hit.auraStat
                        } in ${props.hit.auraLocation}  by ${
                          !props.hit.auraPercentage === 0
                            ? props.hit.auraPercentage
                            : ""
                        }${
                          !props.hit.auraFlatIncrease === 0
                            ? props.hit.auraFlatIncrease
                            : ""
                        }`}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="hidden"></div>
                )}{" "}
                {/* props.hit.auraFlatIncrease && props.hit.auraStat === "Resist" */}
                {props.hit.auraFlatIncrease &&
                props.hit.auraStat === "Speed" ? (
                  <div className="hit-aura">
                    <div className="hit-aura-img-wrap">
                      <GitHubImages whichDirectory="AvatarIconImages/Aura"
                        whichImage="Speed"
                        title={`Increase ${props.hit.auraAffinity} Ally ${
                          props.hit.auraStat
                        } in ${props.hit.auraLocation}  by ${
                          !props.hit.auraPercentage === 0
                            ? props.hit.auraPercentage
                            : ""
                        }${
                          !props.hit.auraFlatIncrease === 0
                            ? props.hit.auraFlatIncrease
                            : ""
                        }`}
                        alt={`Increase ${props.hit.auraAffinity} Ally ${
                          props.hit.auraStat
                        } in ${props.hit.auraLocation}  by ${
                          !props.hit.auraPercentage === 0
                            ? props.hit.auraPercentage
                            : ""
                        }${
                          !props.hit.auraFlatIncrease === 0
                            ? props.hit.auraFlatIncrease
                            : ""
                        }`}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="hidden"></div>
                )}{" "}
                {/* props.hit.auraFlatIncrease && props.hit.auraStat === "Speed" */}
              </div>
            )}{" "}
            {/* props.hit.auraPercentage ? */}
          </div>
        ) : (
          <div className="hidden"></div>
        )}{" "}
        {/* props.hit.auraStat ? */}
        <div className="hit-faction">
          {props.hit.faction.indexOf("Banner Lords") > -1 ? (
            <div className="hit-faction-img-wrap Banner_Lords">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="BannerLords"
                title="Banner Lords Faction"
                alt="Banner Lords Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Barbarians") > -1 ? (
            <div className="hit-faction-img-wrap Barbarians">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="Barbarians"
                title="Barbarians Faction"
                alt="Barbarians Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Dark Elves") > -1 ? (
            <div className="hit-faction-img-wrap Dark_Elves">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="DarkElves"
                title="Dark Elves Faction"
                alt="Dark Elves Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Dwarves") > -1 ? (
            <div className="hit-faction-img-wrap Dwarves">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="Dwarves"
                title="Dwarves Faction"
                alt="Dwarves Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Demonspawn") > -1 ? (
            <div className="hit-faction-img-wrap Demonspawn">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="Demonspawn"
                title="Demonspawn Faction"
                alt="Demonspawn Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("High Elves") > -1 ? (
            <div className="hit-faction-img-wrap High_Elves">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="HighElves"
                title="High Elves Faction"
                alt="High Elves Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Knights Revenant") > -1 ? (
            <div className="hit-faction-img-wrap Knight_Revenant">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="KnightsRevenant"
                title="Knights Revenant Faction"
                alt="Knights Revenant Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Lizardmen") > -1 ? (
            <div className="hit-faction-img-wrap Lizardmen">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="LizardMen"
                title="Lizardmen Faction"
                alt="Lizardmen Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Ogryn Tribes") > -1 ? (
            <div className="hit-faction-img-wrap Ogryn_Tribes">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="OgrynTribes"
                title="Ogryn Tribes Faction"
                alt="Ogryn Tribes Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Orcs") > -1 ? (
            <div className="hit-faction-img-wrap Orcs">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="Orcs"
                title="Orcs Faction"
                alt="Orcs Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Skinwalkers") > -1 ? (
            <div className="hit-faction-img-wrap Skinwalkers">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="Skinwalkers"
                title="Skinwalkers Faction"
                alt="Skinwalkers Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Sacred Order") > -1 ? (
            <div className="hit-faction-img-wrap The_Sacred_Order">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="SacredOrder"
                title="The Sacred Order Faction"
                alt="The Sacred Order Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Undead Hordes") > -1 ? (
            <div className="hit-faction-img-wrap Undead_Hordes">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="UndeadHordes"
                title="Undead Hordes Faction"
                alt="Undead Hordes Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.faction.indexOf("Shadowkin") > -1 ? (
            <div className="hit-faction-img-wrap Undead_Hordes">
              <GitHubImages whichDirectory="AvatarIconImages/Factions"
                whichImage="Shadowkin"
                title="Shadowkin Faction"
                alt="Shadowkin Faction"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
        </div>{/* hit-faction */}
        
        <div className="hit-farmableAt">
          {props.hit.farmableAt ? (
            <div className="hit-farmableAt-img-wrap">
              <GitHubImages whichDirectory="AvatarIconImages/RaidChamps"
                whichImage="farmable"
                title={
                  props.hit.farmableAt
                    ? `Farmable at ${props.hit.farmableAt}`
                    : ""
                }
                alt={
                  props.hit.farmableAt
                    ? `Farmable at ${props.hit.farmableAt}`
                    : ""
                }
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
        </div>{" "}
        {/* hit-farmableAt */}
        <div className="hit-damageBasedOn">
          {props.hit.damageBasedOn.includes("Attack") ? (
            <div className="hit-damageBasedOn-img-wrap Attack">
              <GitHubImages whichDirectory="AvatarIconImages/Damage"
                whichImage="Offense"
                align="left"
                alt="Damage Based On Attack"
                title="Damage Based On Attack"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.damageBasedOn.includes("Defense") ? (
            <div className="hit-damageBasedOn-img-wrap Defense">
              <GitHubImages whichDirectory="AvatarIconImages/Damage"
                whichImage="Defense"
                align="left"
                alt="Damage Based On Defense"
                title="Damage Based On Defense"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.damageBasedOn.includes("N/A") ? (
            <div className="hit-damageBasedOn-img-wrap N-A">
              <GitHubImages whichDirectory="AvatarIconImages/Damage"
                whichImage="Curing"
                align="left"
                alt="Doesn't do any Damage"
                title="Doesn't do any Damage"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.damageBasedOn.includes("HP") ? (
            <div className="hit-damageBasedOn-img-wrap HP">
              <GitHubImages whichDirectory="AvatarIconImages/Damage"
                whichImage="Life"
                align="left"
                alt="Damage Based On HP"
                title="Damage Based On HP"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.damageBasedOn.includes("Max_HP") ? (
            <div className="hit-damageBasedOn-img-wrap HP">
              <GitHubImages whichDirectory="AvatarIconImages/Damage"
                whichImage="Healing"
                align="left"
                alt="Damage Based On Max HP"
                title="Damage Based On Max HP"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.damageBasedOn.includes("Enemy_Max_HP") ? (
            <div className="hit-damageBasedOn-img-wrap HP">
              <GitHubImages whichDirectory="AvatarIconImages/Damage"
                whichImage="Immortal"
                align="left"
                alt="Damage Based On Enemy Max HP"
                title="Damage Based On Enemy Max HP"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
        </div>
        {/* hit-damageBasedOn */}
        <div className="hit-type">
          {props.hit.type.indexOf("Attack") > -1 ? (
            <div className="hit-type-img-wrap Attack">
              <GitHubImages whichDirectory="AvatarIconImages/Types"
                whichImage="Offense"
                align="left"
                alt="Attack Champion"
                title="Attack Champion"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.type.indexOf("Defense") > -1 ? (
            <div className="hit-type-img-wrap Defense">
              <GitHubImages whichDirectory="AvatarIconImages/Types"
                whichImage="Defense"
                align="left"
                alt="Defense Champion"
                title="Defense Champion"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.type.indexOf("Support") > -1 ? (
            <div className="hit-type-img-wrap Support">
              <GitHubImages whichDirectory="AvatarIconImages/Types"
                whichImage="Curing"
                align="left"
                alt="Support Champion"
                title="Support Champion"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.type.indexOf("HP") > -1 ? (
            <div className="hit-type-img-wrap HP">
              <GitHubImages whichDirectory="AvatarIconImages/Types"
                whichImage="Life"
                align="left"
                alt="HP Champion"
                title="HP Champion"
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
        </div>{" "}
        {/* hit-type */}
        <div className="hit-choseNScore">
          {props.hit.choseNLink ? (
            <a
              href={props.hit.choseNLink}
              target="_blank"
              rel="noopener noreferrer"
              alt={`ChoseN Score is ${props.hit.choseNScore} | ${props.hit.chosenConvertedScore} after converted to Base 100 Rating System - Click to Open his Video for this champ in a New Tab`}
              title={`ChoseN Score is ${props.hit.choseNScore} | ${props.hit.chosenConvertedScore} after converted to Base 100 Rating System - Click to Open his Video for this champ in a New Tab`}
            >
              {props.hit.choseNScore <= 1 ? (
                <div
                  className="noStar"
                  alt="Not Rated by ChoseN Yet - Click to Open his YouTube Channel in a New Tab"
                  title="Not Rated by ChoseN Yet - Click to Open his YouTube Channel in a New Tab"
                >
                  N
                </div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 1.1 && props.hit.choseNScore <= 4 ? (
                <div className="oneStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 4.1 && props.hit.choseNScore <= 5.4 ? (
                <div className="twoStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 5.5 && props.hit.choseNScore <= 6.4 ? (
                <div className="threeStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 6.5 && props.hit.choseNScore <= 7.9 ? (
                <div className="fourStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 8 ? (
                <div className="fiveStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
            </a>
          ) : (
            <a
              href="https://www.youtube.com/channel/UCDClIEc8CVfPz8nA8lVHiQQ"
              target="_blank"
              rel="noopener noreferrer"
              className="noVideo"
              alt={`ChoseN Score is ${props.hit.choseNScore} | ${props.hit.chosenConvertedScore} after converted to Base 100 Rating System - Click to Open his Video for this champ in a New Tab`}
              title={`ChoseN Score is ${props.hit.choseNScore} | ${props.hit.chosenConvertedScore} after converted to Base 100 Rating System - Click to Open his Video for this champ in a New Tab`}
            >
              {props.hit.choseNScore <= 1 ? (
                <div
                  className="noStar"
                  alt="Not Rated by ChoseN Yet - Click to Open his YouTube Channel in a New Tab"
                  title="Not Rated by ChoseN Yet - Click to Open his YouTube Channel in a New Tab"
                >
                  N
                </div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 1.1 && props.hit.choseNScore <= 4 ? (
                <div className="oneStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 4.1 && props.hit.choseNScore <= 5.4 ? (
                <div className="twoStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 5.5 && props.hit.choseNScore <= 6.4 ? (
                <div className="threeStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 6.5 && props.hit.choseNScore <= 7.9 ? (
                <div className="fourStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
              {props.hit.choseNScore >= 8 ? (
                <div className="fiveStar">{props.hit.choseNScore}</div>
              ) : (
                <div className="hidden"></div>
              )}
            </a>
          )}
        </div>

        

        <div className="hit-choseNBookValue">
          {props.hit.choseNBookValue >= 1 &&
          props.hit.choseNBookValue <= 5.9 ? (
            <div className="hit-choseNBookValue-img-wrap semi-transparent">
              <GitHubImages whichDirectory="AvatarIconImages/Books"
                whichImage="Skillbook_Rare"
                align="left"
                width="25"
                alt={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
                title={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.choseNBookValue >= 6 &&
          props.hit.choseNBookValue <= 7.9 ? (
            <div className="hit-choseNBookValue-img-wrap">
              <GitHubImages whichDirectory="AvatarIconImages/Books"
                whichImage="Skillbook_Rare"
                align="left"
                width="25"
                alt={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
                title={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.choseNBookValue >= 8 &&
          props.hit.choseNBookValue <= 9.9 ? (
            <div className="hit-choseNBookValue-img-wrap">
              <GitHubImages whichDirectory="AvatarIconImages/Books"
                whichImage="Skillbook_Epic"
                align="left"
                width="25"
                alt={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
                title={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          {props.hit.choseNBookValue >= 10 ? (
            <div className="hit-choseNBookValue-img-wrap">
              <GitHubImages whichDirectory="AvatarIconImages/Books"
                whichImage="Skillbook_Legendary"
                align="left"
                width="25"
                alt={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
                title={
                  props.hit
                    ? `Book Value: ` +
                      props.hit.choseNBookValue
                    : ""
                }
              />
            </div>
          ) : (
            <div className="hidden"></div>
          )}
        </div>{" "}
        {/* hit-choseNBookValue */}
      </div>{" "}
      {/* item-image-wrap */}
      <div className="item-content-wrap">
        <a className="hit-titleLink" href={`${process.env.PUBLIC_URL}/champions/${champSlug}`}>
          <div className="hit-title-wrap">
            <div className="hit-title">{props.hit.title}</div>
          </div>
        </a>
      </div>
      {/* item-content-wrap */}
    </div> /* item-wrap */
  )
}

AlgoliaHits.propTypes = {
  hit: PropTypes.object.isRequired,
}

export default AlgoliaHits
